const makeMosaique = () => {
    const hexContainer = document.querySelector("#hexGrid");
    const hexItem = document.querySelector(".hexLink");
    const sizeHex = hexContainer.getAttribute('data-size-hex');

    if (!hexContainer) {
        return;
    }

    if (!hexItem) {
        return;
    }



    let hexItemMaxNumber = Math.floor(
        hexContainer.clientWidth / sizeHex // ;window.getComputedStyle(hexItem).minWidth.match(/\d+/)[0]
    );

    if( hexItemMaxNumber < 4 ){ 
        hexItemMaxNumber = 4;
    }

    let firstRowNumber = hexItemMaxNumber - 1;
    let hexItemWidth = 100 / hexItemMaxNumber;
    let hexItemWidthPercent = 100 / hexItemMaxNumber + "%";
    let twoRowsHexNumber = hexItemMaxNumber + firstRowNumber;
    let hexItemChildMarginLeft = hexItemWidth / 2 + "%";

    const hexItems = document.querySelectorAll(".hex");

    if (!hexItems.length > 0 ) {
        return;
    }

    for (let hex of hexItems) {
        // console.log(hex);
        hex.style.width = hexItemWidthPercent;
        hex.style.marginTop = -(hex.offsetWidth/3.5) +'px';
        hex.style.marginLeft = 0;
    }

    // hexItems.forEach(hex => {
    //   hex.style.width = hexItemWidthPercent;
    //   hex.style.marginLeft = 0;
    // });

    const hexItemsChild = document.querySelectorAll(
        `.hex:nth-child(${twoRowsHexNumber}n+1)`
    );

    if (!hexItemsChild.length > 0) {
        return;
    }

    for (let hex of hexItemsChild) {
        // console.log(hex);
        hex.style.marginLeft = hexItemChildMarginLeft;
    }

    // hexItemsChild.forEach((hex) => {
    //   // console.log(hex)
    //   hex.style.marginLeft = hexItemChildMarginLeft;
    //   // hex.style.width = hexItemWidth;
    //   console.log(hex.style.width);
    // });
};


export default makeMosaique;
